import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Column, Spinner, TextButton, Typography } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import BankAccountPanel from '~/components/ManagePaymentMethods/BankAccountPanel/BankAccountPanel';
import CreditCardPanel from '~/components/ManagePaymentMethods/CreditCardPanel/CreditCardPanel';
import { useMandateReauthPusherRefresh } from '~/components/ManagePaymentMethods/mandateReauth/hooks/useMandateReauthPusherRefresh/useMandateReauthPusherRefresh';
import { useLocaleKeys } from '~/i18n';
import { paymentMethodModel } from '~/models';
import { SectionCard } from '../SectionCard/SectionCard';
import { usePaymentMethodsCard } from './hooks/usePaymentMethodsCard';
export const GetPaymentMethodsCardTID = (parentTestId)=>getTestIds(parentTestId);
export function PaymentMethodsCard(param) {
    let { clientId, isReadOnly, onAddPaymentMethod } = param;
    const { PaymentMethodsCardTestIds: TID } = useMemo(()=>GetPaymentMethodsCardTID(), []);
    const { t: texts } = useLocaleKeys('client.detail.summary.paymentMethods');
    const { paymentMethods, isLoading, isError, vendorId, apiGatewayHost, refresh, onRemovePaymentMethod } = usePaymentMethodsCard(clientId);
    useMandateReauthPusherRefresh(refresh);
    const content = (()=>{
        if (isLoading) return /*#__PURE__*/ _jsx(Spinner, {
            testId: TID.Loading()
        });
        if (isError) return /*#__PURE__*/ _jsxs(Column, {
            gap: 8,
            alignItems: "start",
            children: [
                /*#__PURE__*/ _jsx(Typography, {
                    testId: TID.Error(),
                    skin: "error",
                    children: texts.loadError()
                }),
                /*#__PURE__*/ _jsx(TextButton, {
                    bi: {
                        name: 'client_detail_payment_methods_retry'
                    },
                    testId: TID.Retry(),
                    skin: "primary",
                    underline: "none",
                    onClick: refresh,
                    children: texts.retry()
                })
            ]
        });
        if (paymentMethods.length === 0) return /*#__PURE__*/ _jsx(Typography, {
            testId: TID.Empty(),
            variant: "paragraph2",
            weight: "light",
            skin: "disabled",
            children: texts.emptyMessage()
        });
        return /*#__PURE__*/ _jsx(Column, {
            testId: TID.List(),
            as: "ul",
            gap: 12,
            children: paymentMethods.map((paymentMethod)=>{
                var _paymentMethod_isRemovable, _paymentMethod_isRemovable1;
                const commonProps = {
                    isSelected: false,
                    isProposal: false,
                    isPaymentMethodInMotion: false,
                    verifyable: false,
                    selectable: false,
                    disconnectable: false,
                    removable: (_paymentMethod_isRemovable = paymentMethod.isRemovable) !== null && _paymentMethod_isRemovable !== void 0 ? _paymentMethod_isRemovable : false,
                    paymentMethodIsRemovable: (_paymentMethod_isRemovable1 = paymentMethod.isRemovable) !== null && _paymentMethod_isRemovable1 !== void 0 ? _paymentMethod_isRemovable1 : false,
                    readOnly: isReadOnly,
                    onSelect: ()=>undefined,
                    onRemove: ()=>onRemovePaymentMethod(paymentMethod)
                };
                return paymentMethodModel.isBankAccount(paymentMethod) ? /*#__PURE__*/ _jsx(BankAccountPanel, _object_spread_props(_object_spread({}, commonProps), {
                    bankAccount: paymentMethod,
                    customerId: clientId,
                    vendorId: vendorId,
                    apiGatewayHost: apiGatewayHost
                }), paymentMethod.id) : /*#__PURE__*/ _jsx(CreditCardPanel, _object_spread_props(_object_spread({}, commonProps), {
                    creditCard: paymentMethod
                }), paymentMethod.id);
            })
        });
    })();
    return /*#__PURE__*/ _jsx(SectionCard, {
        bi: {
            name: 'client_detail_payment_methods_card'
        },
        testId: TID.Root(),
        title: texts.title(),
        showActions: !isReadOnly,
        actions: /*#__PURE__*/ _jsx(TextButton, {
            bi: {
                name: 'client_detail_add_payment_method'
            },
            testId: TID.AddPaymentMethodButton(),
            variant: "paragraph2",
            skin: "primary",
            weight: "normal",
            underline: "none",
            onClick: onAddPaymentMethod,
            children: texts.addPaymentMethod()
        }),
        children: content
    });
}
